import { BaseComponentProps, useComponentData } from '../helpers/contentHooks';
import { MediaHelpers } from '@wajeez-web/core/api';
import { Skeleton } from 'antd';

interface WajeezOfferParameters {
  backgroundImage: string;
  description: string;
  iconImage: string;
  url: string;
}

export const WajeezOffer = ({ component, context }: BaseComponentProps) => {
  const { getParameterValue } = useComponentData<WajeezOfferParameters>(
    component,
    context
  );

  return (
    <div className="w-full px-4 sm:px-[51px]">
      <div
        className="relative px-[10px] py-[13px] flex justify-between items-center rounded-[15px]"
        style={{
          backgroundImage:
            'url(' +
            MediaHelpers.getPublicMediaById(
              getParameterValue('backgroundImage')
            ) +
            ')',
          backgroundSize: 'cover',
        }}
        onClick={() => {
          window.location.href = getParameterValue('url') || '';
        }}
      >
        <p className="w-[60%] text-[14px] font-medium text-right text-white">
          {getParameterValue('description')}
        </p>
        <div className="h-[70px] pl-[14px] skew-y-[-5.5deg]">
          <img
            src={MediaHelpers.getPublicMediaById(
              getParameterValue('iconImage')
            )}
            alt="icon"
            className="h-full"
          />
        </div>
        {/* <div className="w-[120px]">
        <button
          className="mt-[7px] w-full py-1 px-[15px] rounded-full text-[#252525] text-[12px] font-medium"
          style={{
            backgroundImage: 'linear-gradient(90deg, #FFC05C 0%, #FEB03C 100%)',
          }}
          onClick={() => {
            window.location.href = getParameterValue('url') || '';
          }}
        >
          اشترك الآن
        </button>
      </div> */}
      </div>
    </div>
  );
};

const WajeezOfferSkeleton = ({ isActive }: { isActive: boolean }) => {
  return (
    <Skeleton.Node
      className="!w-full !h-[70px] rounded-[12px]"
      active={isActive}
    >
      <div />
    </Skeleton.Node>
  );
};
